// New-UI line grid (concept A): what is left on the line's IO/PO (IO/PO amount less consumed), or null without one.
// Display only.
export const ioRemaining = row => (row && String(row.ioNumber || '').trim() ? (Number(row.poAmount) || 0) - (Number(row.consumedAmount) || 0) : null);
